export type TourPlacement = 'top' | 'bottom' | 'left' | 'right';

export type TourTrigger = 'manual' | 'first-login' | 'first-page-visit';

export interface TourStep {
  id: string;
  /** data-tour attribute value to target, or null for a centered modal step */
  targetSelector: string | null;
  title: string;
  description: string;
  placement?: TourPlacement;
  /** Optional route to navigate to before showing this step */
  routeTo?: string;
}

export interface Tour {
  id: string;
  name: string;
  steps: TourStep[];
  trigger: TourTrigger;
  /** Higher priority tours run first when multiple are queued */
  priority: number;
  /** Pathname prefix where this tour is valid (e.g. '/browse'). Tour auto-dismisses on other pages. */
  pathname?: string;
}

export interface TourProgress {
  completedTours: string[];
  skippedTours: string[];
}

export interface TourState {
  activeTourId: string | null;
  currentStepIndex: number;
  progress: TourProgress;
}

export interface TourContextValue {
  state: TourState;
  activeTour: Tour | null;
  activeStep: TourStep | null;
  isActive: boolean;
  startTour: (tourId: string) => void;
  nextStep: () => void;
  prevStep: () => void;
  skipTour: () => void;
  completeTour: () => void;
  resetTour: (tourId: string) => void;
  resetAllTours: () => void;
  isTourCompleted: (tourId: string) => boolean;
}

export const DEFAULT_TOUR_PROGRESS: TourProgress = {
  completedTours: [],
  skippedTours: [],
};

export const DEFAULT_TOUR_STATE: TourState = {
  activeTourId: null,
  currentStepIndex: 0,
  progress: DEFAULT_TOUR_PROGRESS,
};
